import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Container, TextField, Typography, Box, Alert, InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";
import Global, { isBusinessAccountType } from "../util/Global";
import { AlertContext } from "../util/Alerter";
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';


const LOGIN_URL = Global.backend + "/index.php/loginUser";

const Login2 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const { showAlert } = useContext(AlertContext)

  const [errors, seterrors] = useState({
    email: false,
    pass: false
  })



  const fetchUser = async () => {
    setisLoading(true);
    setMessage("")
    try {
      const response = await axios.post(LOGIN_URL, { email, password });


      if (response.data.message.includes("Email")) {
        setMessage(t("wrongEmail"));
        seterrors({ ...errors, email: true })
      } else if (response.data.message.includes("compte")) {
        setMessage(t("blockedAccount"));
        seterrors({ ...errors, email: true })
      } else if (response.data.message.includes("passe")) {
        setMessage(t("wrongPassword"));
        seterrors({ ...errors, pass: true })
      } else {
        handleLoginSuccess(response.data);
      }

    } catch (error) {

      showAlert("error", t("request.errorLoggingin"))
    } finally {
      setisLoading(false);
    }
  };

  const handleLoginSuccess = (userData) => {
    const user = userData.user;
    localStorage.setItem("token", userData.token)
    localStorage.setItem("email", email);
    localStorage.setItem("nom", user.nom);
    localStorage.setItem("prenom", user.prenom);
    localStorage.setItem("id", user.id);
    localStorage.setItem("compte", user.compte);
    localStorage.setItem("valid", user.is_valid);
    localStorage.setItem("photo", user.photo);
    localStorage.setItem("country", user.pays)


    const isAdmin = user.roles.includes("ROLE_ADMIN");
    localStorage.setItem("roles", user.roles);

    if (isBusinessAccountType(user.compte)) {
      localStorage.setItem("activite", user.entreprise.activite);
      localStorage.setItem("logo", user.entreprise.logo);
      localStorage.setItem("stripeAccountId", user.entreprise.stripeAccountId)
    }

    if (isAdmin) {
      navigate("/dashboard/admin");
    } else {
      navigate("/");
    }
  };

  return (
    <Container component="main" maxWidth="sm" style={{ display: "flex", height: "100vh", alignItems: "center", justifyContent: "center" }}>
      <div className="card shadow-lg w-100">
        <div className="card-body" onKeyDown={(e) => {
          if (e.key === 'Enter') {
            fetchUser()
          }
        }}>

          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img
              src={require("../assets/FrontOffice/images/techoney.png")}
              alt="logo"
              style={{ width: 90 }}
            />
          </Box>
          <Typography variant="h5" component="h1" align="center" gutterBottom>
            {t("login1.1")}
          </Typography>



          <Box component="form" noValidate sx={{ mt: 3, mb: 3 }}>
            <TextField
              variant="outlined"
              margin="normal"

              fullWidth
              label={t("login3.1")}
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon />
                  </InputAdornment>
                )
              }}
              error={errors.email}
            />
            <TextField
              variant="outlined"
              margin="normal"

              fullWidth
              label={t("login4.1")}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <LockIcon />
                  </InputAdornment>
                )
              }}
              error={errors.pass}
            />

            {message && message !== "ok" && (
              <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                {message}
              </Alert>
            )}
          </Box>



          <Button
            disabled={isLoading}
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#ca8d42",
              "&:hover": {
                backgroundColor: "#b07b39"
              },
            }}
            className="mb-3"
            onClick={fetchUser}
          >

            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              t("login1.1")
            )}

          </Button>


          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => navigate("/inscription")}
          >
            {t("login5.1")}
          </Button>
        </div>
      </div>
    </Container>


  );
};

export default Login2;
